export enum ThemeList {
    DEFAULT = 'default',
    GET_RESTO = 'getresto',
    LYF = 'lyf'
}